import * as React from 'react';
import { Input } from 'semantic-ui-react';

function FieldInput(props) {
  const { meta, input } = props;

  return (
    <div className="field-group">
      <Input
        {...props}
        onChange={(event, field) => {
          if (field.maxLength < field.value.length) {
            return;
          } else {
            input.onChange(field.value);
          }
        }}
        onBlur={() => props.input.onBlur(props.input.value)}
        className="input-field"
      />
      {meta.touched && meta.error && (
        <a id="error">
          <div className="redux_form error">{meta.error}</div>
        </a>
      )}
    </div>
  );
}

export default FieldInput;
